import { render, staticRenderFns } from "./HeaderShare.vue?vue&type=template&id=62b86f5a&scoped=true&"
import script from "./HeaderShare.vue?vue&type=script&lang=js&"
export * from "./HeaderShare.vue?vue&type=script&lang=js&"
import style0 from "./HeaderShare.vue?vue&type=style&index=0&id=62b86f5a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b86f5a",
  null
  
)

export default component.exports